import { ICalibration } from '@models/calibrations/calibration';
import { ICalibrationChangelog } from '@models/calibrations/calibration-changelog';

export interface IBetaEstimateQuery {
  ProductId?: number;
  MarketRateId: number;
  PeriodStartDate: string;
  PeriodEndDate: string;
  Lag: number;
}

export interface IBetaCalibration extends ICalibration {
  Id?: number;
  BetaCalibrationId?: number;
  DateTimeCreated?: string;
  DateTimeModified?: string;
  BetaCoefficient: number;
  UserId?: number;
  MarketRateId: number;
  Lag: number;
  ChangeLogs?: ICalibrationChangelog<IBetaCalibration>[];
  /**
   * JSON string of IBetaRegressionResult[]
   */
  Regressions: string;
}

export interface IBetaEstimateResult extends IBetaEstimateQuery {
  Slope: number;
  Intercept: number;
  RSquared: number;
  TStat: number;
  InterceptStandardError: number;
  SlopeStandardError: number;
  InterceptTStat: number;
  SlopeTStat: number;
  FStat: number;
  DegreeFreedom: number;
  StandardError: number;
  PredictedCouponSeries: number[];
  PeriodEndDateSeries: string[];

  Name?: string;
  Id: string;

  /**
   *  Used to describe if a regression has been modified or added but still not saved to the DB
   */
  Modified?: boolean;

  /**
   * Used to describe if a regression has been modified but the still not ran i.e. if the form is no longer pristine
   */
  Pristine?: boolean;

  /**
   * Used to describe if a regression has been re-run and still hasn't finished
   */
  Running?: boolean;

  ValidInput?: boolean;
  ErrMsg?: string;
}

export const EMPTY_BETA_REGRESSION_RESULT: IBetaEstimateResult = {
  MarketRateId: null,
  ProductId: null,
  PeriodStartDate: null,
  PeriodEndDate: null,
  Lag: null,

  Slope: null,
  Intercept: null,
  RSquared: null,
  TStat: null,
  InterceptStandardError: null,
  SlopeStandardError: null,
  SlopeTStat: null,
  InterceptTStat: null,
  FStat: null,
  DegreeFreedom: null,
  StandardError: null,
  PredictedCouponSeries: null,
  PeriodEndDateSeries: null,
  Name: 'New Estimate',
  Id: null,
  Pristine: true,
  ValidInput: true,
  ErrMsg: null
};
